import get from 'lodash.get';
import { getMessages } from 'app/modules';
import sessionEvents from 'events/session';
import messageEnums from 'enums/messages';
import messageEvents from 'events/messages';
import computeUnreadMessageCount from 'actions/messages/computeUnreadMessageCount';
import { trackChatMessageReceived } from 'events/analytics';

export default function handleMessageReceived(message) {
  return (dispatch, getState) => {
    const sortedMessages = getMessages(getState());
    const alreadyReceivedMsg = _hasProcessedMessage(sortedMessages, message);
    const lastMessage = sortedMessages[sortedMessages.length - 1];
    const isStaleMessage = lastMessage.date > message.date;

    // TODO: make this better
    // isStaleMessage guards against rendering "chat has ended" if another session has started
    if (alreadyReceivedMsg || isStaleMessage) {
      return;
    }

    let messageBody = get(message, 'content.body', '');
    dispatch(trackChatMessageReceived({ message: messageBody, messageId: message.id }));

    switch (message.subType) {
      case messageEnums.SUB_TYPES.SESSION_END:
        return dispatch(
          sessionEvents.sessionUpdateSuccess({
            isEnded: true,
            isAgentTyping: false,
            endedReason: messageBody,
          })
        );
      case messageEnums.SUB_TYPES.CREDIT_CARD_REQUEST:
      case messageEnums.SUB_TYPES.IMAGE:
      case messageEnums.SUB_TYPES.FILE:
      case messageEnums.SUB_TYPES.TEXT:
        dispatch(messageEvents.createOrUpdateMessageSuccess(message));
        dispatch(computeUnreadMessageCount);
        return;
    }
  };
}

function _hasProcessedMessage(existingMessages, receivedMessage) {
  if (existingMessages.length) {
    return existingMessages.some(m => {
      return m.id === receivedMessage.id;
    });
  }

  return false;
}
